/* @flow */
import { apiService } from 'services/ServiceRegistry';
import { location, router } from 'api/routes';

export const getCountryLocations: Function = async (companyId: string, countryId: string) => {
  return await apiService.getResource(
    router.generate(location.countryLocations, [companyId, countryId])
  );
};

export const getCompanyUsersPerRole: Function = async (companyId: string, role: string) => {
  return await apiService.getResource(
    router.generate(location.companyUsersPerRole, [companyId, role])
  );
};

export const getCountryUsersPerRole: Function = async (
  companyId: string,
  role: string,
  countryId: string
) => {
  return await apiService.getResource(
    router.generate(location.countryUsersPerRole, [companyId, role, countryId])
  );
};

export const getLocationyUsersPerRole: Function = async (locationId: string, role: string) => {
  return await apiService.getResource(
    router.generate(location.locationUsersPerRole, [locationId, role])
  );
};

// export const getCountryDetails: Function = async (companyId: string, countryId: string) => {
//     return await apiService.getResource(
//         router.generate(location.companyCountryDetails, [companyId, countryId])
//     );
// };

// export const getLocationDetails: Function = async (locationId: string) => {
//     return await apiService.getResource(
//         router.generate(location.locationDetails, [locationId])
//     );
// };

export const getLocationWorkspaces: Function = async (locationId: string, siteId: string) => {
  return await apiService.getResource(
    router.generate(location.locationWorkspaces, [locationId, siteId])
  );
};
